function Success() {
  return (
    <div>
        <h1>Success!</h1>
    </div>
  );
}

export default Success;
